import { DistributionType, EstateType } from '@aviv-search/types';
import { useMobile } from '../useMobile';
const autoPromoDistributionTypes = [
    DistributionType.BUY,
    DistributionType.BUY_AUCTION,
    DistributionType.COMPULSORY_AUCTION,
];
const autoPromoEstateTypes = [EstateType.HOUSE, EstateType.APARTMENT];
const addSuggestion = (suggestedClassifieds, content) => {
    const classifiedId = suggestedClassifieds.shift();
    if (classifiedId) {
        content.push({
            type: 'suggestion',
            classifiedId,
        });
    }
};
export const useListContent = ({ topPositionId, classifiedIds = [], searchModel, adsEnabled = false, ads = { desktop: {}, mobile: {} }, filterVisibleAds, autoPromo, suggestedClassifieds = [], suggestionSlots = [], }) => {
    const { isMobile } = useMobile();
    const suggestedClassifiedsCopy = [...suggestedClassifieds];
    let adsToDisplay = isMobile ? ads.mobile : ads.desktop;
    if (filterVisibleAds) {
        adsToDisplay = filterVisibleAds(adsToDisplay, isMobile);
    }
    const showAutoPromo = !!autoPromo &&
        searchModel?.distributionTypes.every((distributionType) => autoPromoDistributionTypes.includes(distributionType)) &&
        searchModel?.estateTypes?.every((estateType) => autoPromoEstateTypes.includes(estateType));
    const initListContent = topPositionId
        ? [{ type: 'topPositionClassified', classifiedId: topPositionId }]
        : [];
    const listContent = classifiedIds.reduce((acc, id, index) => {
        acc.push({
            type: 'classified',
            classifiedId: id,
        });
        if (showAutoPromo && index === autoPromo?.position) {
            acc.push({
                type: 'auto_promo',
            });
        }
        if (suggestionSlots.includes(index))
            addSuggestion(suggestedClassifiedsCopy, acc);
        const adType = adsEnabled ? adsToDisplay[index] : null;
        if (adType) {
            acc.push({
                type: 'ad',
                adType,
            });
        }
        return acc;
    }, initListContent);
    // Add remaining Suggestions at the end of the list
    suggestionSlots
        ?.filter((slot) => slot >= classifiedIds.length)
        .forEach(() => addSuggestion(suggestedClassifiedsCopy, listContent));
    return listContent;
};
